export default "__VITE_ASSET__BGBnfIYM__"